import React from 'react'
import CustomSelect from '../../../../components/CustomSelect/CustomSelect'

/**
 * 📅 График выплат — выбор схемы, контекстные параметры, раздельная выплата.
 */
export default function PayoutScheduleSection({ settings, onChange }) {
  const rawFreq = settings.payoutFrequency || 'weekly'
  const frequency = rawFreq === 'biweekly' ? 'bi_monthly' : rawFreq

  const schemes = [
    {
      id: 'bi_monthly',
      icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="12" y1="10" x2="12" y2="22"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/></svg>,
      title: '2 раза в месяц',
      desc: '1–15 и 16–конец месяца',
      color: '#8B5CF6'
    },
    {
      id: 'weekly',
      icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/><path d="M7 14h.01M11 14h.01M15 14h.01M7 18h.01"/></svg>,
      title: 'Каждую неделю',
      desc: 'Период пн–вс, выплата в выбранный день',
      color: '#3B82F6'
    },
    {
      id: 'monthly',
      icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="3" y1="10" x2="21" y2="10"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="16" y1="2" x2="16" y2="6"/><path d="M12 14v4M10 16h4"/></svg>,
      title: 'Раз в месяц',
      desc: 'Весь месяц → выплата в фиксированное число',
      color: '#10B981'
    },
    {
      id: 'shifts',
      icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
      title: 'После каждых N смен',
      desc: 'Период = N отработанных смен',
      color: '#F59E0B'
    },
    {
      id: 'daily',
      icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v8M8 12h8"/></svg>,
      title: 'Каждый день',
      desc: 'Каждая смена = отдельный расчёт',
      color: '#EF4444'
    }
  ]

  const dayNames = ['', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']
  const dayNamesShort = ['', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу', 'воскресенье']

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* Карточки выбора схемы */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {schemes.map(scheme => {
          const isActive = frequency === scheme.id
          return (
            <button
              key={scheme.id}
              type="button"
              onClick={() => onChange('payoutFrequency', scheme.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '12px',
                padding: '14px 16px', borderRadius: '12px',
                border: isActive ? `2px solid ${scheme.color}` : '2px solid var(--border-color)',
                background: isActive
                  ? `linear-gradient(135deg, color-mix(in srgb, ${scheme.color} 8%, transparent), color-mix(in srgb, ${scheme.color} 3%, transparent))`
                  : 'var(--surface-color)',
                cursor: 'pointer', textAlign: 'left', transition: 'all 0.2s ease',
                boxShadow: isActive ? `0 2px 12px color-mix(in srgb, ${scheme.color} 15%, transparent)` : 'none',
              }}
            >
              {/* Иконка */}
              <div style={{
                flexShrink: 0, width: '36px', height: '36px', borderRadius: '10px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: isActive
                  ? `linear-gradient(135deg, ${scheme.color}, color-mix(in srgb, ${scheme.color} 70%, #000))`
                  : 'var(--surface-hover)',
                color: isActive ? '#fff' : 'var(--text-secondary)',
                transition: 'all 0.2s ease',
              }}>
                {scheme.icon}
              </div>

              {/* Текст */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  fontSize: '14px', fontWeight: 700,
                  color: isActive ? scheme.color : 'var(--text-primary)',
                  transition: 'color 0.2s',
                }}>
                  {scheme.title}
                </div>
                <div style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.4' }}>
                  {scheme.desc}
                </div>
              </div>

              {/* Radio индикатор */}
              <div style={{
                flexShrink: 0, width: '20px', height: '20px', borderRadius: '50%',
                border: isActive ? `2px solid ${scheme.color}` : '2px solid var(--border-color)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                transition: 'all 0.2s', background: isActive ? scheme.color : 'transparent',
              }}>
                {isActive && (
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </div>
            </button>
          )
        })}
      </div>

      {/* Контекстные параметры */}
      {frequency !== 'daily' && (
        <div style={{
          background: 'var(--surface-hover)', borderRadius: '12px',
          padding: '16px', border: '1px solid var(--border-color)',
        }}>
          <div style={{
            fontSize: '12px', fontWeight: 700, color: 'var(--text-tertiary)',
            textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '12px'
          }}>
            ⚙️ Параметры
          </div>

          {/* Количество смен — для shifts */}
          {frequency === 'shifts' && (
            <div>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px', display: 'block' }}>
                Сколько смен в одном периоде?
              </label>
              <div className="salary-config-input-wrapper" style={{ maxWidth: '200px' }}>
                <input
                  className="input"
                  type="number"
                  min="1"
                  max="100"
                  value={settings.payoutShiftsCount === 0 || settings.payoutShiftsCount === '0' ? '' : (settings.payoutShiftsCount || 10)}
                  placeholder="10"
                  onChange={(e) => onChange('payoutShiftsCount', parseInt(e.target.value) || 0)}
                />
                <span className="salary-config-unit">смен</span>
              </div>
              <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '6px' }}>
                После каждых {settings.payoutShiftsCount || 10} смен система закроет период.
              </div>
            </div>
          )}

          {/* День недели — для weekly и bi_monthly/biweekly */}
          {(frequency === 'weekly' || frequency === 'bi_monthly' || frequency === 'biweekly') && (
            <div>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px', display: 'block' }}>
                В какой день недели платить?
              </label>
              <div style={{ maxWidth: '260px' }}>
                <CustomSelect
                  value={settings.payoutDay || 1}
                  onChange={(val) => onChange('payoutDay', parseInt(val))}
                  options={[
                    { value: 1, label: 'Понедельник' },
                    { value: 2, label: 'Вторник' },
                    { value: 3, label: 'Среда' },
                    { value: 4, label: 'Четверг' },
                    { value: 5, label: 'Пятница' },
                    { value: 6, label: 'Суббота' },
                    { value: 7, label: 'Воскресенье' },
                  ]}
                />
              </div>
              {(frequency === 'bi_monthly' || frequency === 'biweekly') && (
                <div style={{
                  fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '8px',
                  padding: '8px 10px', background: 'var(--surface-color)', borderRadius: '8px', lineHeight: '1.5'
                }}>
                  <strong style={{ color: 'var(--text-secondary)' }}>Как работает:</strong> Месяц делится на 2 периода (1–15 и 16–конец).
                  Выплата — в ближайший {dayNamesShort[settings.payoutDay || 1]} после закрытия периода.
                </div>
              )}
            </div>
          )}

          {/* Число месяца — для monthly */}
          {frequency === 'monthly' && (
            <div>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px', display: 'block' }}>
                Какого числа платить?
              </label>
              <div style={{ maxWidth: '260px' }}>
                <CustomSelect
                  value={settings.payoutDay || 5}
                  onChange={(val) => onChange('payoutDay', parseInt(val))}
                  options={Array.from({ length: 31 }, (_, i) => ({
                    value: i + 1,
                    label: `${i + 1}-го числа следующего месяца`,
                  }))}
                />
              </div>
              <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '6px' }}>
                Зарплата за весь месяц будет выплачена {settings.payoutDay || 5}-го числа следующего месяца.
              </div>
            </div>
          )}
        </div>
      )}

      {/* Раздельная выплата оклада и бонусов */}
      <div style={{
        background: 'var(--surface-color)', borderRadius: '12px',
        border: '1px solid var(--border-color)',
        padding: '16px', transition: 'all 0.2s',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '16px' }}>
          <div style={{ flex: 1 }}>
            <div style={{
              fontWeight: 700, fontSize: '14px', color: 'var(--text-primary)', marginBottom: '3px',
              display: 'flex', alignItems: 'center', gap: '6px'
            }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--wb-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5"/>
              </svg>
              Раздельная выплата
            </div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)', lineHeight: '1.5' }}>
              Оклад — по графику выше. Бонусы — копятся и выплачиваются <strong>раз в месяц</strong> отдельно.
            </div>
          </div>
          <label style={{ position: 'relative', display: 'inline-block', width: 48, height: 26, cursor: 'pointer', flexShrink: 0 }}>
            <input
              type="checkbox"
              checked={settings.payBonusesMonthly || false}
              onChange={(e) => onChange('payBonusesMonthly', e.target.checked)}
              style={{ opacity: 0, width: 0, height: 0 }}
            />
            <span style={{
              position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0,
              background: settings.payBonusesMonthly ? 'var(--wb-primary)' : 'var(--surface-border)',
              borderRadius: 26, transition: 'all 0.3s ease',
            }}>
              <span style={{
                position: 'absolute', height: 20, width: 20,
                left: settings.payBonusesMonthly ? 24 : 3, bottom: 3,
                background: 'white', borderRadius: '50%',
                transition: 'all 0.3s ease', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
              }}></span>
            </span>
          </label>
        </div>

        {settings.payBonusesMonthly && (
          <div style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px solid var(--border-color)', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px', display: 'block' }}>
                Месяц выплаты бонусов
              </label>
              <div style={{ maxWidth: '280px' }}>
                <CustomSelect
                  value={(() => {
                    const rule = (settings.customRules || []).find(r => r.id === 'system:bonus_payout_month_mode')
                    return rule ? rule.value : (settings.bonusPayoutMonthMode || 'next')
                  })()}
                  onChange={(val) => {
                    const existingRules = settings.customRules || []
                    const exists = existingRules.some(r => r.id === 'system:bonus_payout_month_mode')
                    let newRules
                    if (exists) {
                      newRules = existingRules.map(r => r.id === 'system:bonus_payout_month_mode' ? { ...r, value: val } : r)
                    } else {
                      newRules = [...existingRules, { id: 'system:bonus_payout_month_mode', value: val }]
                    }
                    onChange('customRules', newRules)
                    onChange('bonusPayoutMonthMode', val)
                  }}
                  options={[
                    { value: 'next', label: 'В следующем месяце' },
                    { value: 'current', label: 'В текущем месяце' },
                  ]}
                />
              </div>
            </div>

            <div>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-primary)', marginBottom: '6px', display: 'block' }}>
                Число выплаты бонусов
              </label>
              <div style={{ maxWidth: '280px' }}>
                <CustomSelect
                  value={settings.bonusPayoutDay || 5}
                  onChange={(val) => onChange('bonusPayoutDay', parseInt(val))}
                  options={Array.from({ length: 31 }, (_, i) => ({
                    value: i + 1,
                    label: `${i + 1}-го числа`,
                  }))}
                />
              </div>
              <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', marginTop: '6px', lineHeight: '1.5' }}>
                {(() => {
                  const rule = (settings.customRules || []).find(r => r.id === 'system:bonus_payout_month_mode')
                  const isCurrent = (rule ? rule.value : (settings.bonusPayoutMonthMode || 'next')) === 'current'
                  return `Все бонусы за месяц будут доступны для выплаты ${settings.bonusPayoutDay || 5}-го числа ${isCurrent ? 'текущего' : 'следующего'} месяца.`
                })()}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
